import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { summaryTableStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsSummaryTable";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

summaryTableStyles.orderLines = mergeToNew(summaryTableStyles.orderLines, {
    gridContainer: {
        css: css`
            .card_container__wrapper {
                background: ${themeColors.primary.white};
                padding: 20px;
                margin: 0px;
                width: 100%;
            }
        `,
    },

    orderLineCardImage: {
        css: css`
             img {
                width: 103px;
                height: auto;
        `,
    },
    orderLinePriceGridItem: {
        width: [4, 4, 4, 4, 4],

        css: css`
            flex-direction: column;
        `,
    },
});

summaryTableStyles.orderLineCardInfoGridItem = mergeToNew(summaryTableStyles.orderLineCardInfoGridItem, {
    width: [4, 4, 7, 4, 4],
    printWidth: 8,
    css: css`
        @media print {
            &&&& {
                max-width: 100%;
            }
        }
    `,
});
